<h3 class="heading">Showcase App <div class="appversion">{{currentApplicationVersion}}</div> </h3>
  <div id="container"></div>